module.exports = __webpack_public_path__ + "assets/places2_primary.e69cfe86.svg";